var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.177 1c-.325 0-.633.13-.86.357L2.323 8.356a1.304 1.304 0 00-.308.52l-.99 3.393c-.065.195 0 .406.146.569.114.113.26.162.406.162.048 0 .113 0 .162-.016l3.391-.99c.195-.066.374-.163.52-.31l6.993-6.998a1.217 1.217 0 000-1.721l-1.606-1.608a1.215 1.215 0 00-.86-.357h0zM5.21 10.515l-1.72-1.72 4.706-4.71 1.72 1.721-4.706 4.71zm-2.287-.698l1.265 1.267-1.785.52.52-1.787zm8.94-5.992c0 .017 0 .033-.016.065l-1.12 1.104-1.72-1.72 1.104-1.105c.016-.016.048-.016.065-.016.016 0 .032 0 .065.016l1.606 1.608c0 .016.016.032.016.048h0z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "#3CDBC0",
    strokeWidth: 0.25
  })));
}
export default SvgPencil;